/*---- User account constants----------------------------*/
export const USER_ACCOUNT_LOGIN_REQUEST = 'USER_ACCOUNT_LOGIN_REQUEST'
export const USER_ACCOUNT_LOGIN_SUCCESS = 'USER_ACCOUNT_LOGIN_SUCCESS'
export const USER_ACCOUNT_LOGIN_FAILURE = 'USER_ACCOUNT_LOGIN_FAILURE'
export const USER_ACCOUNT_LOGOUT = 'USER_ACCOUNT_LOGOUT'
/*---- User account constants end----------------------------*/